import FullDisplay from './FullDisplay';

import { Amplify, Auth } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

function App() {
  return (
    <>
      <header className="App-header">
      </header>
      <Authenticator>
        {({ signOut, user }) => (
          <body>
            <FullDisplay sign_out={signOut}/>
          </body>
        )}
      </Authenticator>      
    </>
  );
}

export default App;